import httpClient from "../../api/httpClient";
import Grupo from "../classes/GrupoBroadcast";
import { GrupoEmail, GrupoEmailPost } from "../classes/GrupoBroadcastEmail";

interface HttpCalls {
    method: string;
    rota: string;
}

const calls: HttpCalls[] = [
    { method: "GET", rota: "Broadcast/GrupoBroadcastEmail/AllByEmail" },
    { method: "GET", rota: "Broadcast/GrupoBroadcastEmail/AllByGrupo" },
    { method: "POST", rota: "Broadcast/GrupoBroadcastEmail/Adicionar" },
    { method: "DELETE", rota: "Broadcast/GrupoBroadcastEmail/Apagar" },
    { method: "POST", rota: "Broadcast/Desvincular/Email/Grupo" }
];

const cacheKey: string = "GrupoEmailCache";
const cacheKeySelC: string = "GrupoEmailSelecionado";

const apiServico: string = "PORTAL";

class GrupoEmailDataset extends httpClient {

    constructor() {
        super(String(apiServico));
    }

    async AllByEmail(id: number): Promise<GrupoEmail[]> {
        return super.Get(calls[0].rota + '/' + id)
            .then((response) => {
                return JSON.parse(JSON.stringify(response.data));
            })
            .catch((erro) => {
                console.error(erro)
            });
    }

    async AllByGrupo(id: number): Promise<GrupoEmail[]> {
        return super.Get(calls[1].rota + '/' + id)
            .then((response) => {
                return JSON.parse(JSON.stringify(response.data));
            })
            .catch((erro) => {
                console.error(erro)
            });
    }

    async Adicionar(value: GrupoEmailPost) {
        return super.post(calls[2].rota, value)
            .then((result) => {
                return JSON.parse(result);
            }).catch((erro) => {
                console.error(erro);
            });
    }

    async Apagar(value: GrupoEmailPost) {
        return super.delete(calls[3].rota, value)
            .then((result) => {
                return JSON.parse(result);
            }).catch((erro) => {
                console.error(erro);
            });
    }

    async Desvincular(idGrupoEmail: number) {
        return super.post(calls[4].rota + '/' + idGrupoEmail, null)
            .then((result) => {
                return JSON.parse(result);
            }).catch((erro) => {
                console.error(erro);
            });
    }

    getKeyCach(): string {
        return cacheKey;
    }

    getKeyCachClass(): string {
        return cacheKeySelC;
    }

    ListarFromCache(): GrupoEmail[] {
        let result: GrupoEmail[] = JSON.parse(cacheKey);
        return result;
    }

    AdicionarListaAoCache(value: GrupoEmail[]) {
        localStorage.setItem(cacheKey, JSON.stringify(value));
    }

    LimparListaDoCache() {
        localStorage.removeItem(cacheKey);
    }

    AdicionarObjetoAoCache(value: GrupoEmail) {
        localStorage.setItem(cacheKeySelC, JSON.stringify(value));
    }

    LimparObjetoDoCache() {
        localStorage.removeItem(cacheKeySelC);
    }

}
export default GrupoEmailDataset;